
<script>
export default {
  name: 'rex-rounded-star',
  props: {
    label: {
      type: String,
      default: () => null
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    cssClass: {
      type: String,
      default: () => null
    }
  },
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        const data = value.map(x => parseInt(x))

        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value: data
        })

        this.$emit('onChange', {
          event: data,
          element: this.$vnode.elm
        })
      }
    }
  }
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-rounded-field"
  >
    <h3 class="rex-rounded-field--label">
      {{ label }}
    </h3>
    <div class="rex-rounded-stars">
      <div class="rex-rounded-stars--item">
        <input
          id="star-0"
          v-model="value"
          value="0"
          type="checkbox"
        >
        <label for="star-0">
          <span>0+</span>
        </label>
      </div>
      <div class="rex-rounded-stars--item">
        <input
          id="star-2"
          v-model="value"
          value="2"
          type="checkbox"
        >
        <label for="star-2">
          <span>2</span>
        </label>
      </div>
      <div class="rex-rounded-stars--item">
        <input
          id="star-3"
          v-model="value"
          value="3"
          type="checkbox"
        >
        <label for="star-3">
          <span>3</span>
        </label>
      </div>
      <div class="rex-rounded-stars--item">
        <input
          id="star-4"
          v-model="value"
          value="4"
          type="checkbox"
        >
        <label for="star-4">
          <span>4</span>
        </label>
      </div>
      <div class="rex-rounded-stars--item">
        <input
          id="star-5"
          v-model="value"
          value="5"
          type="checkbox"
        >
        <label for="star-5">
          <span>5</span>
        </label>
      </div>
    </div>
  </div>
</template>
